export default {
    setup_title: "Configuración",
    setup_leads_setting: "Ajustes de Leads",
    setup_marketing_source: "Fuente de Marketing",
    setup_quality: "Calidad",
    setup_cta: "CTA (Llamado a la Acción)",
    setup_btn_call_link: "Enlace de Llamada",
    setup_create_call_link: "Crear Enlace de Llamada",
    setup_smart_card: "Tarjeta Inteligente",
    setup_org_info: "Información de la Organización",
    setup_forms_setting: "Ajustes de Formularios",
    setup_list_of_forms: "Lista de Formularios",
    setup_alert_response: "Alerta y Respuesta",
    setup_notifications: "Notificaciones",
    setup_sms_form_noti: "Notificación SMS de Formulario",
    setup_general_setting: "Ajustes Generales",
    setup_language: "Idioma"
}
